import banner from '../assets/images/sample.jpg';

function Banner({ title, description }) {
  return (

    <section className="banner">
        <img src={banner} alt="Banner Image" className="img-fluid" />
        <div className="banner-text">
            <h1 className="display-4">{title}</h1>
            <p className="lead">{description}</p> 
         </div>
    </section> 

  );
}

export default Banner;
